import BookingCalendar from './bookingCalendar';

export default BookingCalendar;